export default {
  imageSetting: {
    title: 'Filter',
  },
  imageEditor: {
    argumentsAreEmpty: 'URL, OnCrop is a must-pass parameter',
  },
}
